var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M7 .875c.423 0 .766.343.766.766v4.593h4.593a.766.766 0 0 1 0 1.532H7.766v4.593a.766.766 0 0 1-1.532 0V7.766H1.641a.766.766 0 0 1 0-1.532h4.593V1.641c0-.423.343-.766.766-.766"
  })));
};
export default SvgPlus;